import { useEffect } from "react";

/**
 * Google Analytics 4 — activates only when REACT_APP_GA4_ID is set in env.
 * Add your Measurement ID (G-XXXXXXXXXX) to /app/frontend/.env to enable.
 */
export default function Analytics() {
  const GA_ID = process.env.REACT_APP_GA4_ID;

  useEffect(() => {
    if (!GA_ID || typeof window === "undefined") return;
    if (window.__ga4_loaded__) return;
    window.__ga4_loaded__ = true;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID, { anonymize_ip: true });
  }, [GA_ID]);

  return null;
}
